import React from "react";

interface IPciStatusAlertProps {
    tone: "warning" | "error";
    heading: string;
    message: string;
}

export default function PciStatusAlert(props: IPciStatusAlertProps) {
    return (
        <div className={`pci-data-alert pci-data-alert--${props.tone}`}
            role={props.tone === "error" ? "alert" : "status"}>
            <span className="pci-data-alert__accent" aria-hidden="true" />
            <div className="pci-data-alert__content">
                <div className="pci-data-alert__text">
                    <p className="pci-data-alert__heading">{props.heading}</p>
                    <p className="pci-data-alert__message">{props.message}</p>
                </div>
            </div>
        </div>
    );
}
